// RTK Query slice for theme management
// Derives data from setupApi (api/auth-restaurant) - no separate API calls
import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "./baseQuery";
import { setupApi } from "./setupApi";

export const themeApi = createApi({
  reducerPath: "themeApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["Theme"],
  endpoints: (builder) => ({
    /**
     * Get theme data from the setupApi cache
     * This doesn't make a new API call - it reads from setupApi's cache
     */
    getTheme: builder.query({
      queryFn: async (_arg, { getState }, _extraOptions, baseQuery) => {
        // Get data from setupApi cache instead of making a new API call
        const setupState = setupApi.endpoints.getRestaurantSetup.select()(getState());

        // If setupApi has an error, propagate it
        if (setupState.error) {
          return { error: setupState.error };
        }

        // Extract data from setupApi cache (even if still loading, return what we have)
        const theme = setupState.data?.theme ?? {};
        const fonts = setupState.data?.fonts ?? {};
        const colors = setupState.data?.colors ?? {};

        return {
          data: {
            theme,
            fonts,
            colors,
          },
        };
      },
      providesTags: ["Theme"],
    }),

    /** Update theme */
    updateTheme: builder.mutation({
      query: (body) => ({
        url: "api/theme",
        method: "POST",
        body,
      }),
      // Invalidate setupApi cache to trigger refetch
      invalidatesTags: (result, error, arg) => {
        return ["Theme", { type: "RestaurantSetup", id: "LIST" }];
      },
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          // Invalidate setupApi to refetch the centralized data
          dispatch(setupApi.util.invalidateTags(["RestaurantSetup"]));
        } catch {}
      },
    }),
  }),
});

export const { useGetThemeQuery, useUpdateThemeMutation } = themeApi;
